export default {"src":"/_next/static/media/PNWD_Logo.a4489155.svg","height":60,"width":240,"blurWidth":0,"blurHeight":0};